import { useEffect, useRef } from 'react';

/**
 * Announces page/view changes to screen readers via the existing
 * #aria-announcer live region defined in index.html.
 *
 * @param viewName - the human-readable name of the current view/page
 */
export function useRouteAnnouncer(viewName: string): void {
    const prevView = useRef<string>('');

    useEffect(() => {
        if (!viewName || viewName === prevView.current) return;

        const announcer = document.getElementById('aria-announcer');
        if (announcer) {
            announcer.textContent = `Navigated to ${viewName}`;
        }

        // Update document title as well for screen readers
        const baseTitle = 'HumanReplica.ai®';
        if (viewName) {
            document.title = `${viewName} | ${baseTitle}`;
        }

        prevView.current = viewName;
    }, [viewName]);
}
